import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import EmptyFilter from "./empty-filter";
import { useSelector } from "react-redux";
import LoaderImg from "@assets/images/loader.gif";

const RangeViewAll = ({ heading, mainFilterList, onSelect, emptyContent, filterKeyword, appliedFilterList, closeFilter, item }) => {
  const [minNum, setMinNum] = useState(mainFilterList[0]);
  const [maxNum, setMaxNum] = useState(mainFilterList[1]);
  const [invalidPlaceHolder, setPlaceHolder] = useState("Please enter valid input");
  const [showPlaceHolder, setShow] = useState(false);
  const filterLoader = useSelector((state) => state.shipmentDetails.filterLoader);

  useEffect(() => {
    if (appliedFilterList.length) {
      setMinNum(appliedFilterList[0]);
      setMaxNum(appliedFilterList[1]);
    } else {
      setMinNum(mainFilterList[0]);
      setMaxNum(mainFilterList[1]);
    }
  }, [mainFilterList, appliedFilterList]);

  function twoDigitFormatter(num) {
    if (num) return Math.round(num * 100) / 100;
    return num;
  }

  function handleMinChange(e) {
    setMinNum(e.target.value);
    if (+e.target.value < 0) {
      setPlaceHolder("*Minimum range cannot be less than 0");
      setShow(true);
      setTimeout(() => {
        setPlaceHolder("Please enter valid input");
        setShow(false);
      }, 2000);
    } else if (e.target.value > maxNum) {
      setShow(true);
      setTimeout(() => {
        setPlaceHolder("Minimum range cannot be more than Maximum range");
        setShow(false);
      }, 2000);
    } else {
      // setMinNum(e.target.value);
    }
  }

  function handleMaxChange(e) {
    setMaxNum(e.target.value);
    if (+e.target.value < minNum) {
      setPlaceHolder(`*Maximum range cannot be less than min range`);
      setShow(true);
      setTimeout(() => {
        setPlaceHolder("Please enter valid input");
        setShow(false);
      }, 2000);
    } else {
      // setMaxNum(e.target.value);
    }
  }

  function onApplyHandler() {
    onSelect({ max: +maxNum, min: +minNum }, item);
    // setRangeValue
  }

  return (
    <Card className="range-view-all-card">
      <Card.Header>
        <div className="d-flex">
          <div className="col-md-5 pl-0">
            <h1 className="header-styling ml-3"> {heading}</h1>
            {/* <input className="form-control" type="text" placeholder={placeholder} onChange={e => onSearch(e.target.value)}></input> */}
          </div>
          <div className="col-md-5 pl-0" />
          <div className="col-md-2 text-right pr-0">
            <button
              type="button"
              disabled={minNum === "" || maxNum === "" || +minNum > +maxNum}
              className="btn btn-primary btn-sm trademo-new-btn"
              onClick={() => {
                onApplyHandler();
                // callForFilter
              }}>
              Apply Filter
            </button>
            <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={closeFilter.bind(this, filterKeyword)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="ml-2">
        {(!!mainFilterList && mainFilterList.length === 2) || (appliedFilterList && appliedFilterList?.length === 2) ? (
          <div>
            <div className="d-flex my-2 ">
              <div className="px-0">
                <span className="range-label">Minimum range</span>
                <input className="box label-styling range-input" type="number" value={twoDigitFormatter(minNum)} onChange={handleMinChange} />
              </div>
              <div className="px-0 ml-4">
                <span className="range-label">Maximum range</span>
                <input className="box label-styling range-input" type="number" value={twoDigitFormatter(maxNum)} onChange={handleMaxChange} />
              </div>
            </div>
            <div className="d-flex">{showPlaceHolder ? <div className="col-12 px-0 label-styling font-red">{invalidPlaceHolder}</div> : <></>}</div>
          </div>
        ) : filterLoader ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
            <img src={LoaderImg} alt="description of gif" />
          </div>
        ) : (
          <EmptyFilter content={emptyContent ? emptyContent : ""} />
        )}
      </Card.Body>
      {/* {filterLoader ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
          <img src={LoaderImg} alt="description of gif" />
        </div>
      ) : null} */}
    </Card>
  );
};

export default RangeViewAll;
